import axios from 'axios';
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient';
import { useNavigate } from 'react-router-dom';

const ActiveSubscriptions = (route) => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;
  const SUBSCRIPTION_STATUSES = [
    "completed",
    "ordered",
    "payment_cancelled",
    "payment_initiated",
    "refunded",
  ];

  const [editingId, setEditingId] = useState(null);
  
const [editDates, setEditDates] = useState({
  startdate: "",
  enddate: "",
  expirydate: "",
  noteByAdmin: "",
  maxmealcount: "",
  subscriptionStatus: "",
});
const handleEdit = (row) => {
  setEditingId(row.id);
  setEditDates({
    startdate: row.startdate,
    enddate: row.enddate,
    expirydate: row.expirydate,
    noteByAdmin: row.noteByAdmin || "",
    maxmealcount: row.maxmealcount || "",
    subscriptionStatus: row.subscriptionStatus || "",

  });
};

const handleDateChange = (e) => {
  const { name, value } = e.target;
  setEditDates((prev) => ({
    ...prev,
    [name]: value,
  }));
};
const handleSave = async (subscriptionId) => {
  try {
    const payload = {
      startdate: editDates.startdate,
      enddate: editDates.enddate,
      expirydate: editDates.expirydate,
      noteByAdmin: editDates.noteByAdmin, 
      maxmealcount: editDates.maxmealcount,
      subscriptionStatus: editDates.subscriptionStatus,
    };

    console.log(payload)
    const response=await apiClient.put(
      `/subscription/update-dates/${subscriptionId}`,
      payload
    );
    const updatedSubscriptionStatus =
      response.data?.subscriptionStatus ?? payload.subscriptionStatus;

    setData((prev) =>
      prev.map((item) =>
        item.id === subscriptionId
          ? { ...item, ...payload, subscriptionStatus: updatedSubscriptionStatus }
          : item
      )
    );

    setEditingId(null);
  } catch (e) {
    console.error(e);
    alert("Failed to update dates");
  }
};

  const navigate = useNavigate()
      const [data, setData] = useState([]);
      const [count,setCount] = useState([]);
      console.log(route);
       const [search, setSearch]=useState("")
      
    
      useEffect(() => {
        const tableData = async () => {
          try {
            const url = `${route.route}${search ? `?search=${encodeURIComponent(search)}` : ''}`;
            const response = await apiClient.get(url);
            const res = await apiClient.get("/subscriptions/user-count");
            setCount(res.data);
            setData(response.data);
            console.log(res.data)
            console.log(response.data);
            
          } catch (e) {
            console.error(e);
          }
        };
        tableData();
      }, [route.route, search]);
      const returnmealplantype=((id)=>{
          if(id==1){
            return "lunch";
          }
          else if(id==2){
            return "dinner";
          }
          else if(id==3){
            return "combo";
          }
          else{
            return "invalid";
          }
      })
    const handlechange=(e)=>{
        const value=e.target.value;
        setSearch(value);
        console.log(value)
    }
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Active Subscriptions</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>

      <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
        <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
          <tr>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Subscription ID</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">User ID</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">User Number</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Plan</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Plan Type</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Start Time</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">End Time</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Address</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Restaurant Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Active Status</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Start Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">End Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Subscription Count</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Count</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Max Count</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Promo Applied</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Subscription Type</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Subscription Status</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Pause Status</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Pause Start Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Pause End Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Admin Note</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Non Discounted Price</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Price</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Coins</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Discount Value</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Expiry Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Number</th>
            {isAdmin && (
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Action</th>
            )}
          </tr>
        </thead>
      <tbody>
        {
          Array.isArray(data) ? data.map((data,index)=>(
        
            <tr key={index} className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.id}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userid}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealPLanName}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplandetails.name}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplantype==1?"Lunch":"Dinner"}</td>
             
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplantype==1?data.lunchstarttime:data.dinnerstarttime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplantype==1?data.lunchendtime:data.dinnerendtime}</td>
                            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.street} {data.city} {data.state} {data.postalCode}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}}>{data.restaurantName}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.isActive ? "Active":"Not Active"}</td>
             
           
           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="date"
      name="startdate"
      value={editDates.startdate}
      onChange={handleDateChange}
      className="border px-1"
    />
  ) : (
    data.startdate
  )}
</td>

<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="date"
      name="enddate"
      value={editDates.enddate}
      onChange={handleDateChange}
      className="border px-1"
    />
  ) : (
    data.enddate
  )}
</td>
 <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{count[data.userid]?count[data.userid]:"null"}</td>
 <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealcount}</td>
  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="number"
      name="maxmealcount"
      value={editDates.maxmealcount}
      onChange={handleDateChange}
      className="border px-1 w-16 text-center mx-auto block"
    />
  ) : (
    data.maxmealcount
  )}
</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.promoApplicable?"Applied":"Not Applied"}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{returnmealplantype(data.mealplantype)}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
                {editingId === data.id ? (
                  <select
                    name="subscriptionStatus"
                    value={editDates.subscriptionStatus}
                    onChange={handleDateChange}
                    className="border px-1"
                  >
                    {SUBSCRIPTION_STATUSES.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                ) : (
                  data.subscriptionStatus
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.ispaused ? "tue":"false"}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{(data.pause_start_date===null )? "-":`${data.pause_start_date}`} </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{(data.pause_end_date===null )? "-":`${data.pause_end_date}`} </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <textarea
      name="noteByAdmin"
      value={editDates.noteByAdmin}
      onChange={handleDateChange}
      className="border px-1 w-40"
    />
  ) : (
    data.noteByAdmin || "-"
  )}
</td>

<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.nonDiscountedPrice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.price}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.coinsUsed}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.discountvalue}</td>    
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="date"
      name="expirydate"
      value={editDates.expirydate}
      onChange={handleDateChange}
      className="border px-1"
    />
  ) : (
    data.expirydate
  )}
</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userdetails.name}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userdetails.number}</td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {isAdmin && (
  editingId === data.id ? (
    <>
      <button
        className="text-green-600 mr-2"
        onClick={() => handleSave(data.id)}
      >
        Save
      </button>
      <button
        className="text-red-600"
        onClick={() => setEditingId(null)}
      >
        Cancel
      </button>
    </>
  ) : (
    <button
      className="text-blue-600 underline"
      onClick={() => handleEdit(data)}
    >
      Edit
    </button>
  )
)}
</td>

            </tr>
          )) : null
        }
        </tbody>
     </table>
      </div>
      

    </div>
    </div>  )
}

export default ActiveSubscriptions